// Generated by CoffeeScript 1.10.0

/*
Tokenizer for tokenizing BBCode tags.
@private
 */

(function() {
  var TagTokenizer;

  TagTokenizer = (function() {

    /*
    Create a new TagTokenizer to tokenize the given string.
    
    @param [String] str
      the string to tokenize
     */
    function TagTokenizer(str) {
      this.str = str;
      this.currentOffset = 0;
      this.nextToken = this._next();
    }


    /*
    Determines if the text is a valid tag (allowed between [ and ]). This is
    currently a member method so that future options can change what's considered
    valid. Currently only A-Z (case insensitive) and a single asterisk (for `[*]`)
    are allowed.
    
    @param [String] tag
      the tag to test
    @return [Boolean]
      whether the tag is a valid tag
     */

    TagTokenizer.prototype.isValidTag = function(tag) {
      return /^\/?(?:[A-Za-z]+|\*)(?:=[^\]]*|="[^"]*")?$/.test(tag);
    };


    /*
    Determines if another token can be read by {#next} or if the end of the string
    has been reached.
    
    @return [Boolean]
      whether another token can be fetched with {#next}
     */

    TagTokenizer.prototype.hasNext = function() {
      return this.nextToken !== null;
    };


    /*
    Gets the next token if there is one, otherwise raises an exception.
     */

    TagTokenizer.prototype.next = function() {
      var nextNext, result;
      if (this.nextToken === null) {
        throw Error("No more tokens");
      }
      result = this.nextToken;
      if (this.nextToken.type === 'text') {
        nextNext = this._next();
        while (nextNext !== null && nextNext.type === 'text') {
          result.text += nextNext.text;
          nextNext = this._next();
        }
        this.nextToken = nextNext;
      } else {
        this.nextToken = this._next();
      }
      if (result.type === 'tag' && result.name.charAt(0) === '/') {
        result.name = result.name.substring(1);
        result.type = 'endtag';
      }
      return result;
    };


    /*
    Internal implementation of next, before multiple text tokens are merged.
    @private
     */

    TagTokenizer.prototype._next = function() {
      var arg, eqIdx, idx, name, raw, tag, tok;
      if (this.currentOffset >= this.str.length) {
        return null;
      }
      if (this.str.charAt(this.currentOffset) === '[') {
        idx = this.str.indexOf(']', this.currentOffset);
        if (idx < 0) {
          tok = {
            type: 'text',
            text: this.str.substring(this.currentOffset)
          };
          this.currentOffset = this.str.length;
          return tok;
        }
        tag = this.str.substring(this.currentOffset + 1, idx);
        if (this.isValidTag(tag)) {
          name = tag;
          arg = null;
          eqIdx = tag.indexOf('=');
          if (eqIdx >= 0) {
            name = tag.substring(0, eqIdx);
            arg = tag.substring(eqIdx + 1);
            if (arg.charAt(0) === '"' && arg.charAt(arg.length - 1) === '"') {
              arg.substring(1, arg.length - 1);
            }
          }
          raw = this.str.substring(this.currentOffset, idx + 1);
          this.currentOffset = idx + 1;
          return {
            type: 'tag',
            name: name.toLowerCase(),
            arg: arg,
            raw: raw
          };
        } else {
          this.currentOffset++;
          return {
            type: 'text',
            text: '['
          };
        }
      } else {
        idx = this.str.indexOf('[', this.currentOffset);
        if (idx < 0) {
          tok = {
            type: 'text',
            text: this.str.substring(this.currentOffset)
          };
          this.currentOffset = this.str.length;
          return tok;
        } else {
          tok = {
            type: 'text',
            text: this.str.substring(this.currentOffset, idx)
          };
          this.currentOffset = idx;
          return tok;
        }
      }
    };

    return TagTokenizer;

  })();

  module.exports = TagTokenizer;

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/bitter-bbcode/lib/tokenizer.js
 ** module id = ./node_modules/bitter-bbcode/lib/tokenizer.js
 ** module chunks = 1
 **/